




































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindMonitoramentoBancoUseCase } from '@/usecases/monitoramento-banco'
import { DatasourceStatus } from '@/api/monitoramento-banco'

const MAX_HISTORICO = 20

@Component
export default class TelaDeMonitoramentoBanco extends Vue {
useCase = new FindMonitoramentoBancoUseCase()

carregando = false
erro = ''
status: DatasourceStatus | null = null
consultadoEm = ''

intervaloRefresh = 30
opcoesIntervalo = [
	{ label: 'Atualização manual', value: 0 },
	{ label: 'A cada 10s', value: 10 },
	{ label: 'A cada 30s', value: 30 },
	{ label: 'A cada 1min', value: 60 },
]

private timer: ReturnType<typeof setInterval> | null = null
	historico = {
		labels: [] as string[],
		escrita: [] as number[],
		leitura: [] as number[],
	}


	cores = {
		writer: '#818cf8',
		reader: '#34d399',
	}

	get temAcesso() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-monitoramento-banco')
	}

	get pctEscrita() {
		if (!this.status) return 0
		return Math.round((this.status.escrita.conexoesAtivas / this.status.escrita.maxConexoes) * 100)
	}

	get pctLeitura() {
		if (!this.status) return 0
		return Math.round((this.status.leitura.conexoesAtivas / this.status.leitura.maxConexoes) * 100)
	}

	get totalAguardando() {
		if (!this.status) return 0
		return this.status.escrita.aguardandoConexao + this.status.leitura.aguardandoConexao
	}

	get statusGeral() {
		if (!this.status) return '—'
		const ok = this.status.escrita.saudavel && this.status.leitura.saudavel
		return ok ? '✔ OK' : '⚠ Atenção'
	}

	get statsEscrita() {
		if (!this.status) return []
		const e = this.status.escrita
		return [
			{ label: 'Ativas', value: e.conexoesAtivas, colorClass: 'indigo--text text--lighten-2' },
			{ label: 'Ociosas', value: e.conexoesOciosas, colorClass: '' },
			{ label: 'Aguard.', value: e.aguardandoConexao, colorClass: e.aguardandoConexao > 0 ? 'warning--text' : '' },
			{ label: 'Máximo', value: e.maxConexoes, colorClass: 'text--secondary' },
		]
	}

	get statsLeitura() {
		if (!this.status) return []
		const l = this.status.leitura
		return [
			{ label: 'Ativas', value: l.conexoesAtivas, colorClass: 'green--text text--lighten-1' },
			{ label: 'Ociosas', value: l.conexoesOciosas, colorClass: '' },
			{ label: 'Aguard.', value: l.aguardandoConexao, colorClass: l.aguardandoConexao > 0 ? 'warning--text' : '' },
			{ label: 'Máximo', value: l.maxConexoes, colorClass: 'text--secondary' },
		]
	}

	get chartOptions() {
		return {
			chart: { toolbar: { show: false }, animations: { enabled: false }, background: 'transparent' },
			theme: { mode: this.$vuetify.theme.dark ? 'dark' : 'light' },
			stroke: { curve: 'smooth', width: 2 },
			fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.3, opacityTo: 0.05 } },
			colors: [this.cores.writer, this.cores.reader],
			xaxis: { categories: this.historico.labels, labels: { show: false }, axisBorder: { show: false } },
			yaxis: { labels: { style: { fontSize: '10px' } } },
			legend: { labels: { colors: this.$vuetify.theme.dark ? '#e0e0e0' : '#444' } },
			grid: { borderColor: this.$vuetify.theme.dark ? '#333' : '#eee' },
			tooltip: { theme: this.$vuetify.theme.dark ? 'dark' : 'light' },
		}
	}

	get chartSeries() {
		return [
			{ name: 'Escrita', data: this.historico.escrita },
			{ name: 'Leitura', data: this.historico.leitura },
		]
	}

	created() {
		if (this.temAcesso) {
			this.carregar()
			this.reiniciarAutoRefresh()
		}
	}

	beforeDestroy() {
		this.pararAutoRefresh()
	}

	async carregar() {
		this.carregando = true
		this.erro = ''
		try {
			this.status = await this.useCase.findStatus()
			const agora = new Date()
			this.consultadoEm = agora.toLocaleTimeString('pt-BR')

			this.historico.labels.push(agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }))
			this.historico.escrita.push(this.status.escrita.conexoesAtivas)
			this.historico.leitura.push(this.status.leitura.conexoesAtivas)

			if (this.historico.labels.length > MAX_HISTORICO) {
				this.historico.labels.shift()
				this.historico.escrita.shift()
				this.historico.leitura.shift()
			}
		} catch (e: any) {
			this.erro = e?.response?.data?.erro || 'Erro ao carregar status dos bancos de dados.'
		} finally {
			this.carregando = false
		}
	}

	reiniciarAutoRefresh() {
		this.pararAutoRefresh()
		if (this.intervaloRefresh > 0) {
			this.timer = setInterval(this.carregar, this.intervaloRefresh * 1000)
		}
	}

	pararAutoRefresh() {
		if (this.timer) {
			clearInterval(this.timer)
			this.timer = null
		}
	}
}
